import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-[133.33vh] bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <div className="w-24 h-24 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-8">
            <svg
              className="w-12 h-12 text-primary-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.291-1.007-5.691-2.622m0 0l-2.183-2.183m16.608-1.891L19.343 7.11"
              />
            </svg>
          </div>

          <h1 className="text-6xl font-bold text-gray-900 mb-4">
            404
          </h1>

          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            Page not found
          </h2>

          <p className="text-gray-600 mb-8 max-w-sm mx-auto">
            The page you're looking for doesn't exist or has been moved to a new location.
          </p>

          <div className="space-y-4">
            <Button
              variant="primary"
              size="lg"
              onClick={() => window.history.back()}
            >
              Go Back
            </Button>

            <div>
              <Link to="/dashboard">
                <Button variant="outline" size="lg">
                  Go to Dashboard
                </Button>
              </Link>
            </div>
          </div>

          <div className="mt-12 text-sm text-gray-500">
            <p>
              Need help? Contact{' '}
              <a
                href="mailto:support@creatorhub.com"
                className="text-primary-600 hover:text-primary-500"
              >
                support@creatorhub.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;